import React, { PureComponent, ReactNode } from "react";
import "./HelpContacts.scss";
import { IContact } from "../../../StrapiService";
import { TFunction } from "i18next";

interface Props {
    contacts: IContact;
    t: TFunction;
}

function InsertIntoString(currentString: string, index: number | undefined, str: string): string {
    return currentString.substring(0, index) + str + currentString.substring(index as number, currentString.length);
}
class HelpContacts extends PureComponent<Props> {
    render(): ReactNode {
        return (
            <div className="help-contacts">
                <h4>
                    {this.props.t("help.needHelpTitle1")}
                    <br />
                    {this.props.t("help.needHelpTitle2")}
                </h4>
                {this.props.contacts.phone && (
                    <a href={`phone:${this.props.contacts.phone}`} className="phone d-flex align-items-center mb-4">
                        <i className="la la-phone pr-4 py-4"></i>
                        {this.props.contacts.phone}
                    </a>
                )}
                {this.props.contacts.email && (
                    <span className="address d-flex align-items-start" style={{ flex: 1, flexWrap: "wrap" }}>
                        <a href={`mailto:${this.props.contacts.email}`} className="email d-flex align-items-center mb-4">
                            <i className="la la-envelope pr-3"></i>
                            {InsertIntoString(this.props.contacts.email, 18, "\n")}
                        </a>
                    </span>
                )}
                {this.props.contacts.address && (
                    <span className="address d-flex align-items-start">
                        <i className="la la-building pt-1 pr-3"></i>
                        {this.props.contacts.address},<br />
                        {this.props.contacts.postcode && this.props.contacts.postcode}
                        <br />
                        {this.props.contacts.city ? this.props.contacts.city : ""}
                    </span>
                )}
                {this.props.contacts.info && (
                    <span className="info d-flex align-items-start pt-3">
                        <i className="la la-book pt-1 pr-3"></i>
                        {this.props.contacts.info}
                    </span>
                )}
            </div>
        );
    }
}

export default HelpContacts;
